const expertiseHelper = ( array, collection, expertiseData ) => {

    const { expertise, markets, sectors, industries } = expertiseData;

    return collection === "expertise" ? array.map ( ele => expertise.find ( e => e.id === ele )) : (
        collection === "markets" ? array.map ( ele => markets.find ( e => e.id === ele ) ) : (
            collection === 'sectors' ? array.map ( ele => sectors.find ( e => e.id === ele ) ) : (
                collection === 'industries' ? array.map ( ele => industries.find ( e => e.id === ele ) ) : null
            )
        )
    )
};

export const handleExperienceSave = ( formData, expertiseData, experienceApiCall ) => {
    //console.log( 'LOG: ************ HANDLE EXPERIENCE SAVE', formData, expertiseData );

    const dataWithNames = {};

    formData.industry_id = formData.industry_id ? JSON.parse(`[ ${ formData.industry_id }]`) : '';
    formData.sector_id = formData.sector_id ? JSON.parse(`[ ${ formData.sector_id }]`) : '';
    formData.market_id = formData.market_id ? JSON.parse(`[ ${ formData.market_id }]`) : '';
    formData.expertise_id = formData.expertise_id ? JSON.parse(`[ ${ formData.expertise_id }]`) : '';
//console.log( 'LOG: form data after parse', formData )
    dataWithNames.expertise_experience = formData.expertise_id !== '' ? expertiseHelper( formData.expertise_id, "expertise", expertiseData) : [];
    dataWithNames.sector_experience = formData.sector_id !== '' ? expertiseHelper( formData.sector_id, "sectors", expertiseData) : [];
    dataWithNames.market_experience = formData.market_id !== '' ? expertiseHelper( formData.market_id, "markets", expertiseData) : [];
    dataWithNames.industry_experience = formData.industry_id !== '' ? expertiseHelper( formData.industry_id, "industries", expertiseData) : [];
//console.log( 'LOG: DATA WITH NAMES', dataWithNames, 'formdata', formData )

    experienceApiCall(formData.person_id, formData, formData.type, dataWithNames);
};





// WEBPACK FOOTER //
// src/client/components/site/features/profile/helpers/experienceHelpers.js